import { render, staticRenderFns } from "./shops.vue?vue&type=template&id=5a078482&scoped=true"
import script from "./shops.vue?vue&type=script&lang=js"
export * from "./shops.vue?vue&type=script&lang=js"
import style0 from "./shops.vue?vue&type=style&index=0&id=5a078482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a078482",
  null
  
)

export default component.exports